import React from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Parser from "html-react-parser";

const QuickNav = () => {
    const { t } = useTranslation('common');
    const navigate = useNavigate()
    const datas = [
        { id: 1, titleKey: 'quick_nav.health_record', textColor: 'text-green_180', bgColor: 'bg-green_10', borderColor: 'border-green_80', linkTo: '/diary' },
        { id: 2, titleKey: 'quick_nav.recommended_meals', textColor: 'text-yellow_180', bgColor: 'bg-yellow_10', borderColor: 'border-yellow_80', linkTo: '/recommend' },
        { id: 3, titleKey: 'quick_nav.meal_record', textColor: 'text-orange_180', bgColor: 'bg-orange_10', borderColor: 'border-orange_80', linkTo: '/meal/record' },
    ]

    return (
        <div className='p-4 border-b border-gray_40'>
            <h2 className='text-caption1_500 text-gray_160 mb-2'>{t('quick_nav.title')}</h2>
            <ul className='flex justify-between'>
                {datas.map(data =>
                    <li onClick={() => navigate(`${data.linkTo}`)} key={data.id} className={'px-4 py-3 text-center border rounded-md ' + `${data.textColor} ${data.bgColor} ${data.borderColor} `}>
                        <h2 className={`text-body3_700 ${data.textColor}`}>{Parser(t(data.titleKey))}</h2>
                    </li>)
                }
            </ul>
        </div >
    );
};

export default QuickNav;